module.exports = __webpack_public_path__ + "static/media/default_brand.94e19c83.svg";